import { Position, Toaster, Intent } from "@blueprintjs/core";

/** Singleton toaster instance. Create separate instances for different options. */
const AppToaster = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
  intent: Intent.SUCCESS,
  timeout: 3000,
});

export { AppToaster };
